export const DEFAULT_TEXTAREA_STYLES = [
  'box-border',
  'resize-none',
  'border',
  'border-solid',
  'bg-primary-white',
  'focus:outline-primary-blue',
  'w-full',
  'rounded-[10px]',
  'px-3.5',
  'h-20',
  'pt-2.5'
].join(' ');

export const INVALID_TEXTAREA_STYLES = ['border-accent-red', 'focus:outline-accent-red'].join(' ');

export const VALID_TEXTAREA_STYLES = 'border-secondary-blue-gray';

export const TEXTAREA_CONTAINER_STYLES = 'space-y-1.5';

export const TEXTAREA_FIELD_LABEL_CONTAINER_STYLES = 'space-y-2.5';

export const TEXTAREA_ERROR_CONTAINER_STYLES = ['flex', 'h-4', 'justify-end', 'flex-1'].join(' ');
